export default function formatToHourMinute(isoString) {
  const date = new Date(isoString);
  
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  
  return `${hours}:${minutes}`;
}
